import React from "react";
import { Helmet } from "react-helmet";
import { useQuery } from "@apollo/client";
import { LoadingFork } from "../../components/LoadingFork";
import { Container, CardContainer } from "../../components/Container";
import { H1, H3, HR, Byline } from "../../components/Typography";
import { getProfile } from "./queries";
import UserForm from "./UserForm";
import PasswordForm from "./PasswordForm";

function ProfilePage() {
  const { data, loading, error, refetch } = useQuery(getProfile, {
    fetchPolicy: "network-only",
  });

  return (
    <CardContainer>
      <LoadingFork
        isLoading={loading}
        error={error}
        render={() => (
          <div>
            <Helmet>
              <title>User Profile</title>
            </Helmet>
            <Container size="medium" spaceBelow="medium">
              <H1>{data?.loggedInUser?.name}</H1>
              <Byline>User Profile</Byline>
              <HR />
            </Container>
            <Container size="medium" spaceBelow="medium">
              <H3>User Details</H3>
              <UserForm User={data?.loggedInUser} onSuccess={refetch} />
            </Container>
            <Container size="medium" spaceBelow="medium">
              <H3>Update password</H3>
              <PasswordForm User={data?.loggedInUser} />
            </Container>
            <Container size="medium" spaceBelow="large">
              <HR />
            </Container>
          </div>
        )}
      />
    </CardContainer>
  );
}

export default ProfilePage;